export type Locale = 'en' | 'fa';
export const defaultLocale: Locale = 'en';
export const localeStorageKey = 'raven.locale';
export const isLocale = (value: unknown): value is Locale => value === 'en' || value === 'fa';
export const getDirection = (locale: Locale): 'ltr' | 'rtl' => (locale === 'fa' ? 'rtl' : 'ltr');

export const resolveLocale = (languages: readonly string[] = []): Locale => {
  for (const language of languages) {
    const base = language.trim().toLowerCase().split('-')[0];
    if (isLocale(base)) {
      return base;
    }
  }
  return defaultLocale;
};

export const resolveRequestLocale = (header?: string | null): Locale => {
  const languages = (header ?? '')
    .split(',')
    .map((entry, index) => {
      const [language = '', ...parameters] = entry.trim().split(';');
      const quality = parameters.find((parameter) => parameter.trim().startsWith('q='));
      return { language, weight: quality ? Number(quality.trim().slice(2)) : 1, index };
    })
    .filter(({ weight }) => Number.isFinite(weight) && weight > 0 && weight <= 1)
    .sort((a, b) => b.weight - a.weight || a.index - b.index);
  return resolveLocale(languages.map(({ language }) => language));
};
